<div class="flex flex-column h-full">
  <div class="flex-grow-1 pl-4 sc-menu-content">

    <div class="flex justify-content-end">
      @if (data.comments.visible$ | async) {
        <p-button (onClick)="openComments()"
                  styleClass="p-button-link"
                  label="Comments: ({{ commentsCount$ | async }})"
                  i18n-label>
        </p-button>
      }

      <ng-content select="[paper-toolbar]"></ng-content>
    </div>

    <ng-content></ng-content>

    @if (!data.buttonsVisible$ || (data.buttonsVisible$ | async) === true) {
      <div class="flex justify-content-between mt-5">
        <p-button [ngStyle]="{ 'visibility': data.previousStepRoute ? 'visible': 'hidden' }"
                  [disabled]="requestInProcess"
                  (onClick)="navigateBack()"
                  styleClass="p-button-link"
                  label="Previous step"
                  i18n-label>
        </p-button>
        @if (data.nextStepRoute) {
          <p-button [disabled]="requestInProcess"
                    (onClick)="navigateNext()"
                    styleClass="p-button-link"
                    label="Next step"
                    i18n-label
                    [loading]="requestInProcess">
          </p-button>
        }
      </div>
    }
  </div>
</div>